/**
 * Image upload size tiers for AI inference path (OCR/Info-Label path uses its own 2 MB limit).
 *
 * Tier 1 (≤ 5 MB): Upload directly without compression — preserves quality for AI inference.
 * Tier 2 (> 5 MB, ≤ 10 MB): Apply compression/resize, ensure final output ≤ 5 MB.
 * Tier 3 (> 10 MB): Reject immediately with error — no compression attempt.
 */
export const MAX_SIZE_WITHOUT_COMPRESSION_MB = 2
export const MAX_COMPRESSED_SIZE_MB = 2
export const MAX_ORIGINAL_IMAGE_SIZE_MB = 10

/** Legacy constant for backward compatibility and OCR path. */
export const MAX_IMAGE_SIZE_MB = 2

/** Upload size tiers for display/error messages. */
export const UPLOAD_SIZE_TIERS = {
  maxWithoutCompression: MAX_SIZE_WITHOUT_COMPRESSION_MB,
  maxFinal: MAX_COMPRESSED_SIZE_MB,
  maxAbsolute: MAX_ORIGINAL_IMAGE_SIZE_MB,
} as const

export function getMaxImageSizeBytes(maxSizeMb: number = MAX_IMAGE_SIZE_MB): number {
  return maxSizeMb * 1024 * 1024
}

export function isFileSizeWithinLimit(sizeInBytes: number, maxSizeMb: number = MAX_IMAGE_SIZE_MB): boolean {
  return sizeInBytes <= getMaxImageSizeBytes(maxSizeMb)
}
